import ninjaApi from 'store/redux/apis/ninja.api';

export const customUrlCostApi = ninjaApi.injectEndpoints({
  tagTypes: ['CustomUrlsCost'],
  overrideExisting: true,
  endpoints: (builder) => ({
    createCustomUrlCost: builder.mutation({
      query: (body) => ({
        url: 'custom-url-cost/create',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['CustomUrlsCost', 'Urls'],
    }),

    updateCustomUrlCost: builder.mutation({
      query: (body) => ({
        url: 'custom-url-cost/update',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['CustomUrlsCost', 'Urls'],
    }),

    findCustomCost: builder.query({
      query: (body) => ({
        url: 'custom-url-cost/find',
        method: 'POST',
        body,
      }),
      providesTags: ['CustomUrlsCost'],
    }),

    deleteUrlCustomCost: builder.mutation({
      query: (body) => ({
        url: 'custom-url-cost/delete',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['CustomUrlsCost', 'Urls'],
    }),
  }),
});

export const {
  useCreateCustomUrlCostMutation,
  useFindCustomCostQuery,
  useUpdateCustomUrlCostMutation,
  useDeleteUrlCustomCostMutation,
} = customUrlCostApi;
